import React from 'react';
import NewOccurrenceReportEditor from './NewOccurrenceReportEditor';
import NewOccurrenceReportCombinedEditor from './NewOccurrenceReportCombinedEditor';
import {NewOccurrenceReportEditorProps} from '../../../../@types/editor-props';
import {ResourceType} from '../../../../@types/resource-type';

export default function NewOccurrenceReportEditorController(props: NewOccurrenceReportEditorProps): React.ReactElement {
    const {occurrence, isActive, updateTab, resourceType} = props;
    const isFoundryEvent = resourceType === ResourceType.FOUNDRY_EVENTS;

    if (isFoundryEvent) {
        return <NewOccurrenceReportEditor occurrence={occurrence} isActive={isActive} updateTab={updateTab} />;
    }

    return <NewOccurrenceReportCombinedEditor occurrence={occurrence} isActive={isActive} updateTab={updateTab} />;
}
